<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <section class="conteudo-principal" id="main">
    <LoadingScreen v-if="whitelabel === 'undefined'" />
    <div v-else>
      <div class="header-content">
        <h1>API V1 {{ whitelabel.name }} {{ selectedLanguage }}</h1>
        <div class="language-version-selector">
          <Select
            :options="versions"
            v-model="selectedVersion"
            keyField="code"
            valueField="code"
            labelField="label"
          />
          <Select
            :options="languages"
            v-model="selectedLanguage"
            keyField="code"
            valueField="code"
            labelField="label"
          />
        </div>
      </div>
      <h3>{{ $t("general.welcome") }}</h3>
      <p>{{ $t("general.api_description") }}</p>

      <h3>{{ $t("general.authentication") }}</h3>
      <p>
        {{ $t("general.authentication_description") }}<br />{{
          $t("general.below_obtain")
        }}
      </p>
      <ul>
        <li>{{ $t("general.login_to_panel") }}</li>
        <li>{{ $t("general.go_to_dashboard") }}</li>
        <li>{{ $t("general.account_info_section") }}</li>
      </ul>

      <p>{{ $t("general.authenticated_request_example_code") }}</p>
      <pre>
curl -G https://{{ whitelabel?.api_domain }}/v1 \\ 
-u '[SEU ID]:[SEU TOKEN]'</pre
      >

      <h3>{{ $t("general.base_url") }}</h3>
      <p>{{ $t("general.base_url_description") }}</p>
      <pre>https://{{ whitelabel?.api_domain }}/v1/</pre>
      <SmsComponent />
      <WppComponent />
      <RcsComponent />
      <EmailComponent />
      <WebhooksComponent />
      <LookupComponent />
      <ContactsComponent />
      <GroupComponent />
      <AccountsInfoComponent />
      <UsersComponent />
      <KeyWordsComponent />
      <OptoutsComponent />
      <BlacklistsComponent />
      <button class="scroll-to-top" @click="scrollToTop">
        <font-awesome-icon :icon="['fas', 'arrow-up']" />
      </button>
    </div>
  </section>
</template>

<script>
import Select from "./Select.vue";
import SmsComponent from "./SmsComponent.vue";
import WppComponent from "./WppComponent.vue";
import RcsComponent from "./RcsComponent.vue";
import EmailComponent from "./EmailComponent.vue";
import WebhooksComponent from "./WebhooksComponent.vue";
import LookupComponent from "./LookupComponent.vue";
import ContactsComponent from "./ContactsComponent.vue";
import GroupComponent from "./GroupComponent.vue";
import AccountsInfoComponent from "./AccountsInfoComponent.vue";
import UsersComponent from "./UsersComponent.vue";
import KeyWordsComponent from "./KeyWordsComponent.vue";
import OptoutsComponent from "./OptoutsComponent.vue";
import BlacklistsComponent from "./BlacklistsComponent.vue";
import LoadingScreen from "../components/LoadingScreen.vue";
import { getUserLocation } from "@/services/ipService";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Main",
  components: {
    Select,
    SmsComponent,
    WppComponent,
    RcsComponent,
    EmailComponent,
    WebhooksComponent,
    LookupComponent,
    ContactsComponent,
    GroupComponent,
    AccountsInfoComponent,
    UsersComponent,
    KeyWordsComponent,
    OptoutsComponent,
    BlacklistsComponent,
    LoadingScreen,
  },
  data() {
    return {
      selectedVersion: "1.0.0",
      versions: [
        { code: "1.0.0", label: "1.0.0", icon: require("@/assets/git.png") },
      ],
      selectedLanguage: this.country,
      languages: [
        { code: "PT-BR", label: "PT-BR", icon: require("@/assets/brasil.png") },
        { code: "EN-US", label: "EN-US", icon: require("@/assets/usa.png") },
        {
          code: "ES-ES",
          label: "ES-ES",
          icon: require("@/assets/espanha.png"),
        },
        { code: "ZH-CN", label: "ZH-CN", icon: require("@/assets/china.png") },
      ],
      isLoading: true,
    };
  },
  async created() {
    try {
      const userLocation = await getUserLocation();
      console.log("IP", userLocation);

      if (userLocation) {
        const country = userLocation.country;

        switch (country) {
          case "US": // Estados Unidos
          case "CA": // Canadá
          case "GB": // Reino Unido (Grã-Bretanha)
          case "UK": // Reino Unido
          case "AU": // Austrália
          case "NZ": // Nova Zelândia
          case "ZA": // África do Sul
            this.selectedLanguage = "EN-US";
            break;

          case "ES": // Espanha
          case "AR": // Argentina
          case "MX": // México
          case "CL": // Chile
          case "CO": // Colômbia
          case "PE": // Peru
            this.selectedLanguage = "ES-ES";
            break;

          case "CN": // China
            this.selectedLanguage = "ZH-CN";
            break;

          case "BR": // Brasil
          case "PT": // Portugal
            this.selectedLanguage = "PT-BR";
            break;

          default:
            this.selectedLanguage = "EN-US";
            break;
        }

        localStorage.setItem("selectedLanguage", this.selectedLanguage);
      } else {
        console.log(
          "Localização do usuário não encontrada. Usando idioma padrão."
        );
      }

      this.$i18n.locale = this.selectedLanguage;
      this.updateTitle();
    } catch (error) {
      console.error("Erro ao obter a localização do usuário:", error);
    } finally {
      this.isLoading = false;
    }
  },
  watch: {
    selectedLanguage(newLanguage) {
      console.log("Mudando idioma para:", newLanguage);
      localStorage.setItem("selectedLanguage", newLanguage);
      this.$i18n.locale = newLanguage;
      this.updateTitle();
    },
  },
  methods: {
    updateTitle() {
      document.title = `API ${this.whitelabel?.name} -V1 (${this.selectedLanguage}) - ${this.selectedVersion}`;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.conteudo-principal {
  padding: 20px;
  overflow-y: auto;
  background-color: white;
  color: #2c3e50;
  margin: 0 200px 0 400px;
  text-align: start;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.conteudo-principal ul {
  margin-bottom: 20px;
  padding-left: 20px;
  list-style-type: disc;
}

.conteudo-principal pre {
  background-color: #f5f5f5;
  font-family: var(--font-code);
  width: none;
  padding: 10px;
  font-size: 14px;
  font-weight: 400;
  border-radius: 5px;
  border: 1px solid #ccc;
  overflow-x: auto;
  margin-bottom: 20px;
  white-space: pre;
  word-wrap: normal;
}

.language-version-selector {
  display: flex;
  gap: 0.5rem;
}

.version-selector select,
.language-selector select {
  border: none;
  border-radius: 6px;
  padding: 10px 14px;
  border: 1px solid #d6d6d6 !important;
  font-weight: 600;
  font-size: 18px;
}

.version-selector select,
.language-selector select {
  border: none;
  border-radius: 6px;
  padding: 10px 14px;
  border: 1px solid #d6d6d6;
  font-weight: 600;
  font-size: 18px;
  cursor: pointer;
}

.version-selector select:hover,
.language-selector select:hover {
  background-color: #d6d6d6;
  border: 1px solid black;
}

.custom-select select option {
  padding: 30px;
  background-color: #fff;
  color: #333;
}

.custom-select select option:checked {
  background-color: var(--color-default) !important;
  color: #fff;
}

.scroll-to-top {
  position: fixed;
  width: 42px;
  bottom: 20px;
  right: 20px;
  background-color: var(--color-default);
  color: white;
  border: none;
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  font-size: 20px;
  z-index: 1000;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: opacity 0.3s ease;
}

.scroll-to-top:hover {
  background-color: var(--purple-hover);
  bottom: 25px;
  transition: opacity 1s ease;
}

.scroll-to-top.hidden {
  opacity: 0;
  pointer-events: none;
}

@media (max-width: 960px) {
  .conteudo-principal {
    width: 80%;
    margin: 1rem;
    padding: 2rem;
  }
}
</style>
